import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getImagingUltrasoundSelector } from '../selectors'
import { ImagingUltrasoundConstants } from '../store/imagingUltrasound.constants'
import { IImagingUltrasoundState } from '../store/ImagingUltrasound.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const imagingUltrasoundState: IImagingUltrasoundState = yield select(getImagingUltrasoundSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = imagingUltrasoundState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === ImagingUltrasoundConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([ImagingUltrasoundConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
